import { Container, Typography, Box } from "@mui/material"

function Maintenance() {
    return (
        <Container sx = {{height: "100vh", display: "flex", justifyContent: 'center', alignItems: "center"}}>
            <Box>
            <Typography sx = {{textAlign:"center"}}variant = "h5">Baron's menu is currently under maintenance.</Typography>
            <br/>
            <Typography sx = {{textAlign: "center"}} variant = "h6">It will be available on 18/12/2025 at 9:00 AM.</Typography>

            </Box>
        
        </Container>
    )
}

export default Maintenance;